import React from 'react';
import './Cart.less';
import CartComp from '@components/cart/Cart';

type Props = {};

const Cart: React.FC<Props> = () => {
  return <CartComp />;
};

export default Cart;
